import { render, staticRenderFns } from "./AssetCertificates.vue?vue&type=template&id=132d6d2e&scoped=true"
import script from "./AssetCertificates.vue?vue&type=script&lang=js"
export * from "./AssetCertificates.vue?vue&type=script&lang=js"
import style0 from "./AssetCertificates.vue?vue&type=style&index=0&id=132d6d2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132d6d2e",
  null
  
)

export default component.exports